import React from 'react'

import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { TextField, Grid } from '@material-ui/core'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { useField } from 'formik'
import moment from 'moment-timezone'

const DateTimeInput = (props) => {
  let {
    value,
    name,
    timeLabel,
    minDate,
    maxDate,
    onChange,
    showTime = true,
    is24hrFormat,
    disabled = false
  } = props
  const [field, meta] = useField(props)
  const dateError =
    meta.error && meta.touched && meta.error.errType === 'Date' ? meta.error.msg : ''
  const timeError =
    meta.error && meta.touched && meta.error.errType === 'Time' ? meta.error.msg : ''
  return (
    <Grid container>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <div style={{ display: 'flex', gap: '5px', marginBottom: '10px' }}>
          <div style={{ maxWidth: '140px' }}>
            <DesktopDatePicker
              label={timeLabel}
              inputFormat="MM/DD/YYYY"
              name={name}
              value={value}
              onChange={onChange}
              minDate={minDate}
              maxDate={maxDate}
              disabled={disabled}
              renderInput={({ inputProps, ...rest }) => {
                return (
                  <TextField
                    {...rest}
                    helperText={dateError}
                    error={!!dateError}
                    {...field}
                    inputProps={{
                      ...inputProps,
                      value: value && moment(value).format('MM/DD/YYYY'),
                      readOnly: true
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                    disabled={disabled}
                  />
                )
              }}
            />
          </div>
          {showTime && (
            <div style={{ maxWidth: '120px', marginLeft: '8px' }}>
              <TimePicker
                name={name}
                value={value}
                label={' '}
                onChange={onChange}
                closeOnSelect={false}
                ampm={!is24hrFormat}
                disabled={disabled}
                renderInput={({ inputProps, ...rest }) => (
                  <TextField
                    {...rest}
                    {...field}
                    {...props}
                    helperText={timeError}
                    error={!!timeError}
                    inputProps={{ ...inputProps, placeholder: 'hh:mm', readOnly: true }}
                    InputLabelProps={{
                      shrink: true
                    }}
                    disabled={disabled}
                  />
                )}
              />
            </div>
          )}
        </div>
      </LocalizationProvider>
    </Grid>
  )
}

export default DateTimeInput
